import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { ROUTE_MAP } from '@common/constants/route-map';
export const ServiceCenter = () => {
    const { t } = useTranslation();
    return (_jsx(Link, Object.assign({ href: ROUTE_MAP.HOME }, { children: _jsx("span", Object.assign({ className: "px-4 cursor-pointer" }, { children: t('common:languageHeader.serviceCenter') })) })));
};
